import { Link } from 'react-router-dom';
import './Footer.scss';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container container">
        <div className="footer-links">
          <Link to="/privacy" className="footer-link">Privacy Policy</Link>
          <span className="footer-separator">|</span>
          <Link to="/terms" className="footer-link">Terms of Use</Link>
        </div>
        <p className="footer-copyright">
          &copy; {currentYear} Valendris LLC. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
